export const pluralize = (
  count: number,
  word: string,
  pluralWord?: string
): string => {
  if (count === 1) {
    return word
  }

  return pluralWord || `${word}s`
}
